import { RatingIcons, Stack } from '@packages/shared';
import { useConfig } from '@packages/utilities';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { RatingInfo } from '../CustomerRatings/RatingInfo';

const RatingIconsVerifiedFragment = graphql(/* GraphQL */ `
  fragment RatingIconsVerifiedFragment on RatingProduct {
    avgRating
    reviewCount
  }
`);

export type RatingIconsVerifiedProps = {
  data: FragmentType<typeof RatingIconsVerifiedFragment>;
};

/**
 * RatingIconsVerified component shows review-icons,
 * the amount of given ratings and an information-icon
 * */
export const RatingIconsVerified = ({ data }: RatingIconsVerifiedProps) => {
  const {
    product: {
      reviews: { hintLayerId },
    },
  } = useConfig();
  const { avgRating, reviewCount } = getFragmentData(RatingIconsVerifiedFragment, data);

  return (
    <Stack direction="row">
      <RatingIcons
        avgRating={avgRating}
        reviewCount={reviewCount}
        sx={{
          cursor: 'pointer',
        }}
        onClick={() => {
          document
            .getElementById('customer-ratings')
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }}
      />
      <RatingInfo verifiedRatingsHintLayerId={hintLayerId} />
    </Stack>
  );
};
